import { useQuery } from "@tanstack/vue-query"
import { ContentType } from "~/models/Content/ContentType"

export function useMarketing() {
  const { cms } = useRuntimeConfig().public

  const getContent = useGetContent()

  return useQuery({
    queryKey: ["marketing", cms.pagesLocationId] as const,
    staleTime: 60 * 60 * 1000, // 1 hour
    queryFn({ queryKey }) {
      return getContent({
        childDepth: 3,
        contentType: [ContentType.Page, ContentType.Folder],
        parentLocationId: [parseInt(queryKey[1], 10)],
        sortField: "priority",
      })
    },
    select(items) {
      return {
        pages: items
          .filter(isContentType(ContentType.Page))
          .map(page => ({
            ...page,
            sections: page.children.filter(isContentType(ContentType.PageSection)),
          })),
        marketingArticles: items
          .filter(isContentType(ContentType.Folder))
          .flatMap(it => it.children)
          .filter(isContentType(ContentType.MarketingArticle))
          .map(article => ({
            ...article,
            sections: article.children.filter(isContentType(ContentType.MarketingArticleSection)),
          })),
      }
    },
  })
}
